import { IShareBaseSocket, SocketSubject } from '../sockets';
import { SocketFactory } from '../socket-factory';
import { AuthService } from 'phoenix/services';

export type IDocumentViewService = DocumentViewService;

/**
 * A service that exposes methods for joining a web socket room for a single document.
 * It also exposes properties about the room.
 */
export class DocumentViewService {
    public static $inject = [
        '$timeout',
        'sbrtsSocketFactory',
        'pxAuthService'
    ];

    private docId: number;
    private socket: IShareBaseSocket;
    private roomUsers: SocketSubject[];

    /**
     * An array of users in the room, including the current user.
     */
    public get users():SocketSubject[] {
        return this.roomUsers;
    }

    /**
     * An array of users in the room that excludes the current user.
     */
    public otherUsers: SocketSubject[];

    constructor(
        private readonly $timeout,
        private readonly factory: SocketFactory,
        private readonly auth: AuthService
    ) { }

    /**
     * Join a document room with the given document id.
     */
    public joinRoom(documentId: number | string) {
        if (typeof documentId === 'string') {
            documentId = parseInt(documentId, 10);
        }

        if (documentId !== this.docId) {
            this.docId = documentId;

            let roomNo = `document-view-${this.docId}`;
            // leave the current room
            this.leaveRoom();

            this.factory.create()
                .then(socket => {
                    this.socket = socket;
                    this.socket.joinRoom(roomNo, users => {
                        this.roomUsers = this.getUniqueUsers(users);
                        this.otherUsers = this.roomUsers.filter(u => u.userId !== this.auth.userId);
                    });
                });
        }
    }

    /**
     * Leave the current document room.
     */
    public leaveRoom() {
        if (this.socket) {
            this.socket.disconnect();
            this.docId = -1;
        }
    }

    private getUniqueUsers(users: SocketSubject[]) {
        let uhash: { [index: number]: SocketSubject } = { };
        for (let u of users) {
            if (!(u.userId in uhash)) {
                uhash[u.userId] = u;
            }
        }

        return Object.keys(uhash).map((key) => uhash[key]);
    }
}


// WEBPACK FOOTER //
// ./src/real-time/view-services/document-view.service.ts